import React from 'react'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import HomeIcon from '@mui/icons-material/Home';
import AddIcon from '@mui/icons-material/Add';
import InventoryIcon from '@mui/icons-material/Inventory';
import MapIcon from '@mui/icons-material/Map';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ImageIcon from '@mui/icons-material/Image';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import FolderIcon from '@mui/icons-material/Folder';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FilterListIcon from '@mui/icons-material/FilterList';
import QrCodeIcon from '@mui/icons-material/QrCode';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DoneAllOutlinedIcon from '@mui/icons-material/DoneAllOutlined';
import DriveFileMoveOutlinedIcon from '@mui/icons-material/DriveFileMoveOutlined';
import TransferWithinAStationOutlinedIcon from '@mui/icons-material/TransferWithinAStationOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SecurityIcon from '@mui/icons-material/Security';
import LockIcon from '@mui/icons-material/Lock';
import ConstructionIcon from '@mui/icons-material/Construction';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import MenuIcon from '@mui/icons-material/Menu';
import DownloadIcon from '@mui/icons-material/Download';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ArticleIcon from '@mui/icons-material/Article';
import PrintIcon from '@mui/icons-material/Print';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MarkunreadIcon from '@mui/icons-material/Markunread';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import TopicIcon from '@mui/icons-material/Topic';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';

export const iconTypesArray = [
  "show", "hide", "success", "error", "warning", "home", "new", "inventory", "map", "delete", "options", "image",
  "search", "edit", "folder", "folder-open", "folders", "topic", "arrow-down", "list", "refresh", "filter", "qrcode", "close", "info",
  "done", "move", "transfer", "arrow-right", "back", "file", "users", "user", "profile", "admin", "security", "lock",
  "repair", "missing", "prev", "next", "menu", "brands", "download", "pdf", "document", "print", "request", "settings",
  "mail", "dark-mode", "light-mode", "copy",
] as const;

export type IconTypes = typeof iconTypesArray[number];

interface Props {
    icon: IconTypes
}

export default function GenerateIcon(props: Props) {

    const { icon } = props

    switch(icon){

        case "show":
            return <Visibility />

        case "hide":
            return <VisibilityOff />

        case "success":
            return <CheckIcon />

        case "error":
            return <ErrorIcon />

        case "warning":
            return <WarningIcon />
        
        case "home":
            return <HomeIcon />

        case "new":
            return <AddIcon />
        
        case "inventory":
            return <InventoryIcon />

        case "map":
            return <MapIcon />

        case "delete":
            return <DeleteIcon />

        case "options":
            return <MoreVertIcon />

        case "image":
            return <ImageIcon />

        case "search":
            return <SearchIcon />

        case "edit":
            return <EditIcon />

        case "folder":
            return <FolderIcon />

        case "folders":
            return <FolderCopyIcon />

        case "topic":
            return <TopicIcon />

        case "folder-open":
            return <FolderOpenIcon />

        case "arrow-down":
            return <KeyboardArrowDownIcon />

        case "list":
            return <ListAltIcon />

        case "refresh":
            return <RefreshIcon />

        case "filter": 
            return <FilterListIcon />

        case "qrcode":
            return <QrCodeIcon />

        case "close":
            return <CloseIcon />

        case "info":
            return <InfoOutlinedIcon />

        case "done":
            return <DoneAllOutlinedIcon />

        case "move":
            return <DriveFileMoveOutlinedIcon />

        case "transfer":
            return <TransferWithinAStationOutlinedIcon />

        case "arrow-right":
            return <ArrowForwardIosOutlinedIcon />

        case "back":
            return <ArrowBackIosNewOutlinedIcon />

        case "file":
            return <InsertDriveFileOutlinedIcon />

        case "users":
            return <PeopleIcon />

        case "user":
            return <PersonIcon />
            
        case "profile":
            return <AssignmentIndIcon />

        case "admin":
            return <AdminPanelSettingsIcon />

        case "security":
            return <SecurityIcon />

        case "lock":
            return <LockIcon />
        
        case "repair":
            return <ConstructionIcon />

        case "missing":
            return <SearchOffIcon />

        case "prev":
            return <NavigateBeforeIcon />

        case "next":
            return <NavigateNextIcon />

        case "menu":
            return <MenuIcon />

        case "brands":
            return <FeaturedPlayListIcon />

        case "download":
            return <DownloadIcon />

        case "pdf":
            return <PictureAsPdfIcon />

        case "document":
            return <ArticleIcon />

        case "print":
            return <PrintIcon />
        
        case "request":
            return <AssignmentIcon />

        case "settings":
            return <ManageAccountsIcon />

        case "mail":
            return <MarkunreadIcon />

        case "dark-mode":
            return <DarkModeIcon />

        case "light-mode":
            return <LightModeIcon />

        case "copy":
            return <ContentPasteIcon />

        default:
            return <></>
    }
}
